import React, { useEffect, useState } from "react";
import logo from "../Assets/Logo.png";
import { getSelfBookingPackage } from "../Common/apis.js";

const PackageDetails = () => {
  const [PackageData, setPackageData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackageData();
  }, []);

  const fetchPackageData = async () => {
    try {
      const result = await getSelfBookingPackage();
      setPackageData(result?.data || []);
    } catch (error) {
      console.error("Error fetching package details:", error);
    } finally {
      setLoading(false);
    }
  };

  // Function to download invoice
  const handlePrint = (id) => {
    const invoiceElement = document.getElementById(`invoice-${id}`);
    if (invoiceElement) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Package Invoice</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              .invoice-container { width: 210mm; margin: auto; padding: 20px; background: #fff; border: 1px solid #ddd; }
              .invoice-header { text-align: center; margin-bottom: 20px; }
              .invoice-header img { max-width: 100px; }
              .invoice-title { font-size: 24px; color: #849348; }
              .invoice-table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              .invoice-table td, .invoice-table th { border: 1px solid #ddd; padding: 10px; text-align: left; }
              .invoice-footer { text-align: center; margin-top: 20px; font-size: 12px; color: #555; }
            </style>
          </head>
          <body>
            ${invoiceElement.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  if (loading) {
    return   <div className="loader"></div>;
  }

  return (
    <div className="profile-plan">
      <h2 className="Select">My Packages</h2>
      <br />
      <div className="encourage-cards">
        {PackageData.length > 0 ? (
          PackageData.map((packageInfo) => {
            const { _id, userId, packageId, packageType, status, paymentStatus, totalCount, useCount, remainCount, transactionId } = packageInfo;

            return (
              <div>
              <div key={_id} className="encourage-card">
                <h3>Package: {packageId?.name || "N/A"}</h3>
                <h4>Type: {packageType}</h4>
                <p>Days Included: {packageId?.noOfDays || "N/A"}</p>
                <p>Amount: ₹{packageId?.amount || "N/A"}</p>
                <p>Status: <strong>{status}</strong></p>
                <p>Payment: <strong>{paymentStatus}</strong></p>
                <p>Used: {useCount} / {totalCount}</p>
                <p>Remaining: {remainCount}</p>

                {/* Download Invoice Button */}
                <button 
                  onClick={() => handlePrint(_id)}
                  style={{
                    marginTop: "10px",
                    padding: "10px 15px",
                    backgroundColor: "#849348",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer"
                  }}
                >
                  Invoice
                </button>

                {/* Invoice Template (Hidden by default) */}
                <div id={`invoice-${_id}`} className="hidden-template" style={{ display: "none" }}>
                  <div className="invoice-container">
                    <div className="invoice-header">
                      <img src={logo} alt="Company Logo" />
                      <h1 className="invoice-title">Package Invoice</h1>
                      <p>Thank you for purchasing a package with us!</p>
                    </div>

                    <table className="invoice-table">
                      <tbody>
                        <tr>
                          <td><strong>Customer Name:</strong></td>
                          <td>{userId?.name || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Email:</strong></td>
                          <td>{userId?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Mobile:</strong></td>
                          <td>{userId?.mobile || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Package Name:</strong></td>
                          <td>{packageId?.name || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Description:</strong></td>
                          <td>{packageId?.description || "No Description Available"}</td>
                        </tr>
                        <tr>
                          <td><strong>Package Type:</strong></td>
                          <td>{packageType}</td>
                        </tr>
                        <tr>
                          <td><strong>Total Days:</strong></td>
                          <td>{packageId?.noOfDays || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Amount:</strong></td>
                          <td>₹{packageId?.amount || "N/A"}</td>
                        </tr>
                        <tr>
                          <td><strong>Status:</strong></td>
                          <td>{status}</td>
                        </tr>
                        <tr>
                          <td><strong>Payment Status:</strong></td>
                          <td>{paymentStatus}</td>
                        </tr>
                        <tr>
                          <td><strong>Total Count:</strong></td>
                          <td>{totalCount}</td>
                        </tr>
                        {/* <tr>
                          <td><strong>Used Count:</strong></td>
                          <td>{useCount}</td>
                        </tr>
                        <tr>
                          <td><strong>Remaining Count:</strong></td>
                          <td>{remainCount}</td>
                        </tr>
                        <tr>
                          <td><strong>Transaction ID:</strong></td>
                          <td>{transactionId}</td>
                        </tr> */}
                      </tbody>
                    </table>

                    <div className="invoice-footer">
                      <p>For any queries, contact our support at info@aluradubai.com</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            );
          })
        ) : (
          <p>No packages found.</p>
        )}
      </div>
    </div>
  );
};

export default PackageDetails;
